// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basic-course[data-v-22742176]{margin-top:10px}.basic-course-banner[data-v-22742176]{padding:0 12px}.basic-course-filter[data-v-22742176]{padding:32px 0;border-bottom:1px solid rgba(17,19,23,.1);margin:0 12px 20px}.basic-course-list[data-v-22742176]{display:flex;flex-flow:row wrap}.basic-course .pagination[data-v-22742176]{margin-top:56px}", ""]);
// Exports
module.exports = exports;
